import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../../shared';

import { ChartActiveBarSummaryComponent } from './components/chart-active-bar-summary/chart-active-bar-summary.component';
import { ChartBarDescriptionComponent } from './components/chart-bar-description/chart-bar-description.component';
import { ChartBarComponent } from './components/chart-bar/chart-bar.component';
import { ChartComponent } from './components/chart/chart.component';
import { PeriodSummaryComponent } from './components/period-summary/period-summary.component';

@NgModule({
  declarations: [
    ChartActiveBarSummaryComponent,
    ChartComponent,
    ChartBarComponent,
    ChartBarDescriptionComponent,
    PeriodSummaryComponent,
  ],
  imports: [CommonModule, SharedDependenciesModule],
  exports: [ChartComponent],
})
export class ChartBarModule {}
